import * as React from "react";
import { BrowserRouter as Router, Route } from "react-router-dom";
import App from './app';
import Pricelist from './pricelist';
import Renew from './renew';

export default function AppRouter() {
    return <Router>
        <React.Fragment>
            <Route path="/" exact={true} component={App} />
            <Route path="/pricelist" component={Pricelist} />
            <Route path="/renew" component={Renew} />
        </React.Fragment>
    </Router>;
}


// WEBPACK FOOTER //
// ./src/router.tsx